import { LoadingOverlay } from '@mantine/core';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { useParams } from 'react-router-dom';
import { SmallModal } from '../../../components/SmallModal';
import { useModal } from '../../../hooks/useModal';
import { mutate } from '../../../util/api/mutate';
import type { PrescriptionDto } from '../types/PrescriptionDto';

interface VerifyPrescriptionModalProps {
	close: () => void;
	isOpened: boolean;
	displayDate: ReactNode;
	prescriptionId: number;
	updateTableRow: Dispatch<SetStateAction<PrescriptionDto>>;
}

export function VerifyPrescriptionModal({
	close,
	isOpened,
	displayDate,
	prescriptionId,
	updateTableRow,
}: VerifyPrescriptionModalProps) {
	const { organisation } = useParams();

	const completeModal = useModal();

	const verifyMutation = mutate<PrescriptionDto>(
		`${organisation}/prescriptions/verify/${prescriptionId}`,
	);

	return (
		<>
			<LoadingOverlay
				bg={'#000'}
				opacity={0.85}
				visible={verifyMutation.isLoading}
			/>
			<SmallModal
				isOpen={isOpened}
				close={close}
				title={'Verify Prescription'}
				body={
					<>
						Are you sure you want to verify the prescription record of date{' '}
						<i>{displayDate}</i>? Click OK to confirm...
					</>
				}
				onComplete={async () => {
					close();

					await verifyMutation
						.mutateAsync()
						.then((data) =>
							updateTableRow((current) => ({
								...current,
								verifiedBy: data.value.verifiedBy,
							})),
						)
						.then(() => completeModal.open());
				}}
			/>
			<SmallModal
				isOpen={completeModal.isOpen}
				close={completeModal.close}
				title={'Verification Complete'}
				body={
					<>
						Verification of <i>{displayDate}</i> has successfully completed.
						Click OK to continue...
					</>
				}
			/>
		</>
	);
}
